import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@cmps/ng-bootstrap';

import { WidgetConfiguration } from '../widget/config.widget.model';
import { ModalWidgetComponentRef } from '../widget/modal.widget.component';
import {
    CMPS_WIDGET_CONFIG,
    CMPS_WIDGET_MODAL_HANDLE,
    CMPS_WIDGET_OPTIONS,
} from '../widget/widget.metadata';

import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';
import { PersonalCoaching } from './personal-coaching.widget.model';

@Component({
    selector: 'cmps-widget-personal-coaching',
    templateUrl: './personal-coaching.widget.component.html',
})
export class PersonalCoachingWidgetComponent implements OnInit {
    i18n = TranslationKeyMap;
    hasPendingData: boolean;
    data: PersonalCoaching;
    isTeamMode: boolean;

    constructor(
        private readonly _router: Router,
        @Optional()
        @Inject(CMPS_WIDGET_CONFIG)
        public config: WidgetConfiguration,
        @Optional()
        @Inject(CMPS_WIDGET_MODAL_HANDLE)
        public modalHandle: ModalWidgetComponentRef,
        @Optional() @Inject(CMPS_WIDGET_OPTIONS) private readonly _options: any,
        @Optional() public activeModal: NgbActiveModal,
        private readonly _service: LegacyWidgetService,
    ) {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        this.isTeamMode = this._options && this._options.performerType != null;
    }

    ngOnInit(): void {
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, no-return-assign
        const onDone = () => (this.hasPendingData = false);
        this.hasPendingData = true;
        if (!this.isTeamMode) {
            this._service
                .personalCoaching()
                // eslint-disable-next-line no-return-assign
                .subscribe((data) => (this.data = data), onDone, onDone);
        } else {
            // TODO revise
            this._service
                .teamCoachingPopup(this._options.performerType)
                // eslint-disable-next-line no-return-assign, @typescript-eslint/consistent-type-assertions
                .subscribe(
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    (data) => (this.data = <PersonalCoaching>data),
                    onDone,
                    onDone,
                );
        }
    }

    goToJournal(url: string): void {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._router.navigate(['internal', 'webform'], {
            queryParams: { relativeUrl: url },
        });
        if (this.activeModal != null && this.isTeamMode) {
            this.activeModal.close();
        }
    }
}
